import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  InputNumber,
  Upload,
  Radio,
  Icon,
  message,
  Spin,
  Tooltip,
  Select
} from 'antd'
import numeral from 'numeral'
import moment from 'moment'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/jobInvoiceActions'
import { actions as auditActions } from '../../../redux/modules/auditActions'
import { filterCaseInsensitive, getModalId } from '../../../util'
import styled from 'styled-components'
import history from '../../../history'
import _ from 'lodash'

const { Option } = Select

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const FormItem = Form.Item
const { TextArea } = Input
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const propTypes = {}

class JobInvoices extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      selectedRevision: 0
    }

    // define user id (filter from dashboard)
    let userId = 0
    if (this.props.user.isAdmin) {
      userId = this.props.selectedUser && this.props.fromDashboard ? this.props.selectedUser : 0
    } else {
      userId = this.props.fromDashboard ? this.props.user.userId : 0
    }

    this.props.jobInvoicesRefresh({
      jobId: this.props.fromDashboard ? 0 : this.props.jobId,
      assignedToId: userId,
      fromDashboard: this.props.fromDashboard ? true : false,
      next: payload => {
        if (this.shouldRenderModal()) {
          const selectedInvoice =
            payload.data && payload.data.find(d => String(d.id) === String(this.state.currentId))
          this.props.getInvoiceAttachments({
            invoiceId: selectedInvoice.id
          })
          this.setState({
            modalVisible: true,
            currentId: selectedInvoice.id,
            contentData: selectedInvoice
          })
          this.props.getAuditRevisions({
            targetId: selectedInvoice.id,
            table: 'invoice'
          })
        }
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.auditActions.revisions !== nextProps.auditActions.revisions) {
      const last = _.last(nextProps.auditActions.revisions.data)
      this.setState({
        selectedRevision: last !== undefined ? last.revision - 1 : 0
      })
    }
  }

  handleRevisionChange = revisionNumber => {
    const { form } = this.props
    const revisions = this.getRevisions()

    const revision = revisions[revisionNumber]

    this.setState({
      selectedRevision: revisionNumber
    })

    let changes = {}
    const jsonPatch = JSON.parse(revision.json_patch)
    jsonPatch.forEach(op => {
      if (op.path === '/0') {
        changes = op.value
      } else {
        const fieldName = op.path.substring(1, op.path.length)
        if (!_.isNil(form.getFieldsValue()[fieldName])) {
          changes[fieldName] = op.value
        }
      }
    })

    form.setFieldsValue(changes)
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shortcutItemId &&
      this.props.jobInvoiceActions.jobInvoices !== prevProps.jobInvoiceActions.jobInvoices
    ) {
      const highLightEstimate = _.filter(
        this.props.jobInvoiceActions.jobInvoices.data,
        estimate => estimate.id === this.props.shortcutItemId
      )
      this.handleRowClick(highLightEstimate[0])
      this.props.clearHighlight()
    }

    const { selectedUser } = this.props
    if (selectedUser !== prevProps.selectedUser) {
      this.props.jobInvoicesRefresh({
        jobId: this.props.fromDashboard ? 0 : this.props.jobId,
        assignedToId: this.props.selectedUser ? this.props.selectedUser : 0,
        fromDashboard: this.props.fromDashboard ? true : false
      })
    }
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  handleRowClick = row => {
    this.setState(
      {
        modalVisible: true,
        currentId: row.id,
        contentData: row
      },
      () => {
        this.props.getInvoiceAttachments({
          invoiceId: row.id
        })
        this.props.getAuditRevisions({
          targetId: row.id,
          table: 'invoice'
        })
        const { jobType, jobId } = this.props.match.params
        history.push(`/jobView/${jobId}/${jobType}/invoices/modal/${row.id}`)
      }
    )
  }

  handleAddButton = () => {
    this.setState(
      {
        modalVisible: true,
        currentId: 0,
        contentData: null
      },
      () => {
        const { jobType, jobId } = this.props.match.params
        history.push(`/jobView/${jobId}/${jobType}/invoices/modal/0`)
        this.forceUpdate()
      }
    )
  }

  redirectToInvoices = () => {
    const { jobType, jobId } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/invoices`)
    this.forceUpdate()
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false }, this.redirectToInvoices)
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      values.invoice_date = values.invoice_date
        ? moment(values.invoice_date).format('YYYY-MM-DD hh:mm:ss')
        : null
      values.fromDashboard = this.props.fromDashboard
      values.selectedUser = this.props.selectedUser

      if (this.state.currentId === 0) {
        this.props.createJobInvoice({
          jobId: this.props.jobId,
          content: values,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateJobInvoice({
          jobId: this.props.jobId,
          invoiceId: this.state.currentId,
          content: values,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState(
        { contentData: null, currentId: 0, modalVisible: false },
        this.redirectToInvoices
      )
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteJobInvoice({
      jobId: this.props.jobId,
      invoiceId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState(
      {
        contentData: null,
        currentId: 0,
        modalVisible: false
      },
      this.redirectToInvoices
    )
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'invoice')
    formData.append('created_by_id', this.props.user.userId)
    formData.append('updated_by_id', this.props.user.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('invoiceId', this.state.currentId)

    this.props.uploadInvoiceAttachment({
      formData: formData,
      invoiceId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateInvoiceAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      invoiceId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteInvoiceAttachment({
      attachmentId: this.state.attachmentId,
      invoiceId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  getRevisions() {
    return (
      this.props.auditActions &&
      this.props.auditActions.revisions &&
      this.props.auditActions.revisions.data
    )
  }

  render() {
    const { contentData } = this.state
    const { loading } = this.props.auditActions
    const revisions = this.getRevisions()
    const currentRevision =
      _.has(revisions, this.state.selectedRevision) && revisions[this.state.selectedRevision]

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form
    if (!this.props.jobInvoiceActions.jobInvoices) {
      return <Loader />
    }
    return (
      <div>
        {this.shouldRenderModal() && (
          <Modal
            visible={true}
            title="Invoice"
            okText={contentData ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            maskClosable={false}
          >
            <Form layout="vertical">
              {contentData && (
                <div className="row">
                  <div className="col-3">
                    <FormItem label="Revision">
                      {loading ? (
                        <Spin size="small" />
                      ) : (
                        <Select
                          value={this.state.selectedRevision}
                          onChange={this.handleRevisionChange}
                        >
                          {revisions &&
                            revisions.map(revision => (
                              <Option
                                key={revision.revision}
                                value={revision.revision - 1} // revision index
                              >
                                {revision.revision}
                              </Option>
                            ))}
                        </Select>
                      )}
                    </FormItem>
                  </div>
                </div>
              )}
              {contentData && (
                <FormItem label="Created Date">
                  {moment(contentData.created_date).format('M/D/YYYY')}
                </FormItem>
              )}
              {contentData &&
                currentRevision && (
                  <FormItem label="Updated Date">
                    {moment(currentRevision.updated_date).format('M/D/YYYY')}
                  </FormItem>
                )}
              {contentData && (
                <FormItem label="Created By">
                  {`${contentData.created_by_first_name} ${contentData.created_by_last_name}`}
                </FormItem>
              )}
              {currentRevision &&
                contentData && (
                  <FormItem label="Updated By">
                    {`${currentRevision.created_by_first_name} ${
                      currentRevision.created_by_last_name
                    }`}
                  </FormItem>
                )}
              {contentData && (
                <FormItem label="Status">
                  {getFieldDecorator('status', {
                    initialValue: contentData ? contentData.status : ''
                  })(
                    <RadioGroup>
                      <RadioButton value="Sent">Sent</RadioButton>
                      <RadioButton value="Rejected">Rejected</RadioButton>
                      <RadioButton value="Paid">Paid</RadioButton>
                    </RadioGroup>
                  )}
                </FormItem>
              )}
              <FormItem label="External Invoice Number">
                {getFieldDecorator('invoice_number', {
                  rules: [
                    {
                      required: true,
                      message: 'External invoice number cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.invoice_number : ''
                })(
                  <Input
                    placeholder="Enter the invoice number..."
                    rows={4}
                    initialvalue={contentData ? contentData.invoice_number : ''}
                  />
                )}
              </FormItem>
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  rules: [
                    {
                      required: true,
                      message: 'Note description cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.description : ''
                })(
                  <TextArea
                    placeholder="Describe the attachment..."
                    rows={4}
                    initialvalue={contentData ? contentData.description : ''}
                  />
                )}
              </FormItem>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Amount">
                    {getFieldDecorator('amount', {
                      rules: [
                        {
                          required: true,
                          message: 'Amount has to be higher than zero.'
                        }
                      ],
                      initialValue: contentData && contentData.amount
                    })(
                      <InputNumber
                        placeholder="$ 0.00"
                        formatter={value =>
                          value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : null
                        }
                      />
                    )}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Term">
                    {getFieldDecorator('term', {
                      initialValue: contentData ? contentData.term : 0
                    })(<InputNumber />)}
                  </FormItem>
                </div>
              </div>
              {contentData && (
                <FilesUploadContainer>
                  <div className="row">
                    <div className="col-md-6">
                      <h5>
                        <Icon type="check" /> Invoice Files
                      </h5>
                    </div>
                    <div className="col-md-6 text-right">
                      {this.props.jobInvoiceActions &&
                        this.props.jobInvoiceActions.uploadingAttachment && (
                          <div className="text-success">
                            <Icon type="loading" /> Uploading File(s)
                          </div>
                        )}
                      {this.props.jobInvoiceActions &&
                        this.props.jobInvoiceActions.deletingAttachment && (
                          <div className="text-danger">
                            <Icon type="loading" /> Deleting File(s)
                          </div>
                        )}
                    </div>
                  </div>
                  {this.props.jobInvoiceActions.invoiceAttachments &&
                    this.props.jobInvoiceActions.invoiceAttachments.data.length > 0 && (
                      <Spin spinning={this.props.jobInvoiceActions.loadingAttachments}>
                        <ReactTable
                          defaultPageSize={5}
                          defaultFilterMethod={filterCaseInsensitive}
                          data={this.props.jobInvoiceActions.invoiceAttachments.data}
                          getTrProps={(state, rowInfo, column, instance) => ({
                            onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                          })}
                          columns={[
                            {
                              Header: 'Attached Files',
                              columns: [
                                {
                                  Header: 'Filename',
                                  id: 'filename',
                                  accessor: 'filename',
                                  Cell: d => (
                                    <Tooltip title={d.original.filename}>
                                      {d.original.filename}
                                    </Tooltip>
                                  )
                                },
                                {
                                  Header: 'Description',
                                  id: 'description',
                                  accessor: d => (
                                    <Tooltip title={d.description}>{d.description}</Tooltip>
                                  )
                                },
                                {
                                  Cell: row => (
                                    <Tooltip
                                      placement="left"
                                      title="Open this file on a new window"
                                    >
                                      <a target="_blank" href={row.original.signedUrl}>
                                        <Icon type="export" className="fontSize20" />
                                      </a>
                                    </Tooltip>
                                  ),
                                  maxWidth: 35
                                }
                              ]
                            }
                          ]}
                          defaultSorted={[
                            {
                              id: 'id',
                              desc: true
                            }
                          ]}
                          className="-striped -highlight"
                        />
                      </Spin>
                    )}
                  {this.state.attachmentDetailsVisible && (
                    <EditAttachmentContainer>
                      <EditAttachmentTitle>
                        <Icon type="edit" /> Edit Attachment Area
                      </EditAttachmentTitle>
                      <div>
                        <EditingFileContainer>
                          <Icon type="file" /> {this.state.attachmentName}
                        </EditingFileContainer>
                      </div>
                      <div className="row">
                        <div className="col-md-10">
                          <TextArea
                            placeholder="Describe the attachment..."
                            rows={4}
                            onChange={this.onDescriptionChange}
                            value={this.state.attachmentDescription}
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-row mt-2">
                        <Button onClick={this.handleUpdateAttachmentDescription}>
                          <Icon type="save" /> OK
                        </Button>{' '}
                        <Popconfirm
                          title="Are you sure you want to delete this attachment?"
                          onConfirm={this.confirmAttachmentDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button type="danger" icon="delete" className="ml-2">
                            {' '}
                            DELETE
                          </Button>
                        </Popconfirm>
                      </div>
                    </EditAttachmentContainer>
                  )}
                  <br />
                  <div>Upload Invoice File(s)</div>
                  <br />
                  <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                    <Button>
                      <Icon type="upload" /> Upload
                    </Button>
                  </Upload>
                </FilesUploadContainer>
              )}
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={this.confirmDelete}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                {contentData && <Button type="danger" icon="delete" />}
              </Popconfirm>
            </Form>
          </Modal>
        )}
        <div className="jobsBar">
          Job Invoices
          {!this.props.fromDashboard && (
            <div className="jobsBarAdd">
              <i className="fa fa-plus-square" aria-hidden="true" />
              &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
                ADD Invoice
              </div>
            </div>
          )}
        </div>
        {this.props.jobInvoiceActions.jobInvoices &&
          !this.props.fromDashboard && (
            <ReactTable
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              getTrProps={(state, rowInfo, column, instance) => ({
                onClick: e => this.handleRowClick(rowInfo.original)
              })}
              data={this.props.jobInvoiceActions.jobInvoices.data}
              columns={[
                {
                  columns: [
                    {
                      Header: 'External Invoice Number',
                      accessor: 'invoice_number',
                      sortMethod: (a, b) => (parseInt(a) > parseInt(b) ? 1 : -1)
                    },
                    {
                      Header: 'Amount',
                      id: 'amount',
                      sortMethod: (a, b) => {
                        const amount1 = numeral(a.props.title)
                        const amount2 = numeral(b.props.title)
                        return amount1.value() > amount2.value() ? 1 : -1
                      },
                      accessor: d => {
                        const r = numeral(d.amount).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      }
                    },
                    {
                      Header: 'Term',
                      id: 'term',
                      sortMethod: (a, b) =>
                        parseInt(a.props.title) > parseInt(b.props.title) ? 1 : -1,
                      accessor: d => <Tooltip title={d.term}>{d.term}</Tooltip>
                    },
                    {
                      Header: 'Status',
                      accessor: 'status'
                    },
                    {
                      Header: 'Created By',
                      id: 'created_by',
                      accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                      width: 160,
                      Cell: d => {
                        const r = `${d.original.created_by_first_name} ${
                          d.original.created_by_last_name
                        }`
                        return <Tooltip title={r}>{r}</Tooltip>
                      }
                    },
                    {
                      Header: 'Updated By',
                      id: 'updated_by',
                      accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                      width: 160,
                      Cell: d => {
                        const r = `${d.original.updated_by_first_name} ${
                          d.original.updated_by_last_name
                        }`
                        return <Tooltip title={r}>{r}</Tooltip>
                      }
                    },
                    {
                      Header: 'Created Date',
                      id: 'created_date',
                      accessor: d => moment(d.created_date).format('M/D/YYYY'),
                      sortMethod: (a, b) => {
                        if (moment(a, 'M/D/YYYY').isBefore(moment(b, 'M/D/YYYY'))) {
                          return -1
                        }
                        return 1
                      }
                    }
                  ]
                }
              ]}
              defaultPageSize={10}
              className="-striped -highlight"
            />
          )}
        {this.props.jobInvoiceActions.jobInvoices &&
          this.props.fromDashboard && (
            <ReactTable
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              getTdProps={(state, rowInfo, column, instance) => ({
                onClick: e => {
                  if (column.Header !== 'Job') {
                    this.handleRowClick(rowInfo.original)
                  }
                }
              })}
              data={this.props.jobInvoiceActions.jobInvoices.data}
              columns={[
                {
                  columns: [
                    {
                      Header: 'Job',
                      id: 'job',
                      accessor: d => `${d.job_id} - ${d.job_name}`,
                      Cell: row => {
                        const r = `${row.original.job_id} - ${row.original.job_name}`
                        return (
                          <Tooltip title={r}>
                            <Link to={`/jobView/${row.original.job_id}/${row.original.job_type}`}>
                              {r}
                            </Link>
                          </Tooltip>
                        )
                      },
                      minWidth: 150
                    },
                    {
                      Header: 'External Invoice Number',
                      accessor: 'invoice_number'
                    },
                    {
                      Header: 'Amount',
                      id: 'amount',
                      accessor: d => {
                        const r = numeral(d.amount).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      }
                    },
                    {
                      Header: 'Term',
                      id: 'term',
                      accessor: d => <Tooltip title={d.term}>{d.term}</Tooltip>
                    },
                    {
                      Header: 'Status',
                      accessor: 'status'
                    }
                  ]
                }
              ]}
              defaultPageSize={10}
              className="-striped -highlight"
            />
          )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobInvoiceActions, auditActions }, ownProps) => ({
  jobInvoiceActions,
  auditActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, auditActions), dispatch)
})

JobInvoices.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobInvoices)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobInvoices.js